import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS } from '../../pages/app/reports/groups-teams-activity/constants';

interface TogglePillOption {
    key: string;
    label: string;
    count: number;
    countColor?: 'blue' | 'red';
}

interface TogglePillsProps {
    options: TogglePillOption[];
    activeKey: string;
    onChange: (key: string) => void;
}

export const TogglePills: React.FC<TogglePillsProps> = ({ options, activeKey, onChange }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                backgroundColor: COLORS.grayLight,
                borderRadius: '8px',
                padding: '3px',
            }}
        >
            {options.map((opt) => {
                const isActive = opt.key === activeKey;
                const countBg = isActive
                    ? opt.countColor === 'red'
                        ? '#FEE2E2'
                        : COLORS.blueLight
                    : COLORS.border;
                const countColor = isActive
                    ? opt.countColor === 'red'
                        ? COLORS.red
                        : COLORS.blueDark
                    : COLORS.grayMedium;

                return (
                    <Box
                        key={opt.key}
                        onClick={() => onChange(opt.key)}
                        sx={{
                            padding: '5px 14px',
                            borderRadius: '6px',
                            fontSize: '12px',
                            fontWeight: 500,
                            color: isActive ? COLORS.textPrimary : COLORS.grayDark,
                            cursor: 'pointer',
                            backgroundColor: isActive ? '#fff' : 'transparent',
                            boxShadow: isActive ? '0 1px 3px rgba(0,0,0,.08)' : 'none',
                            transition: 'all .15s',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            userSelect: 'none',
                        }}
                    >
                        {opt.label}
                        <Typography
                            component="span"
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '18px',
                                height: '16px',
                                borderRadius: '8px',
                                fontSize: '10px',
                                fontWeight: 600,
                                padding: '0 4px',
                                backgroundColor: countBg,
                                color: countColor,
                            }}
                        >
                            {opt.count}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
};
